import React, { createContext, useState } from 'react';

const DEFAULT_VALUE = {
    state: {
		isHome: true,
        displaySearch: true,
    },
    setState: () => {},
}

const LayoutContext = createContext(DEFAULT_VALUE);

const LayoutContextProvider = ({children}) => {
    const [state, setState] = useState(DEFAULT_VALUE.state);
    return (
        <LayoutContext.Provider value={{ state, setState }}>
            { children }
        </LayoutContext.Provider>
    )
}

export { LayoutContextProvider };
export default LayoutContext;
